import {
  BasicSearchable,
  Button,
  SearchableCustomEvent
} from '@vmware-react/clarity';
import React from 'react';
import { DSearchSelectField, DSearchSelectValue } from './types';

interface Props {
  field: DSearchSelectField;
  value: DSearchSelectValue;
  error?: string;
  touched?: boolean;
  hidden?: boolean;
  modalDOM?: HTMLDivElement;
  handleChange: (event: SearchableCustomEvent) => void;
  handleBlur: (event: SearchableCustomEvent) => void;
}

export default (props: Props) => {
  const {
    field,
    error,
    touched,
    hidden,
    value,
    modalDOM,
    handleChange,
    handleBlur
  } = props;
  const hasError = typeof error === 'string' && error.length > 0;

  return (
    <div className="crc-df__search-select-wrapper">
      <div>
        <BasicSearchable
          name={field.name}
          label={field.label}
          required={field.required}
          hidden={hidden}
          error={hasError && touched}
          errorMessage={error}
          helpText={field.helperText}
          helpTextPosition={field.helperTextPosition}
          helperTextToolTipConfig={field.helperTextToolTipConfig}
          value={value}
          disabled={field.disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          options={field.options}
          modalDOM={modalDOM}
          placeholder={field.placeholder}
        />
      </div>

      {field.buttonClickHandler && (
        <div>
          <Button
            icon={true}
            type="button"
            family="link"
            onClick={field.buttonClickHandler}
            title={field.buttonHelperText}>
            <clr-icon shape="plus-circle" size="20" />
          </Button>
        </div>
      )}

      {field.buttonElement && !field.buttonClickHandler && (
        <div>{field.buttonElement}</div>
      )}
    </div>
  );
};
